import { render, staticRenderFns } from "./SelectTax.vue?vue&type=template&id=5f1a3a33&"
import script from "./SelectTax.vue?vue&type=script&lang=js&"
export * from "./SelectTax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports